(function () {
  const productHeroSliders = document.querySelectorAll('.js_product_hero_slider');

  productHeroSliders.forEach(slider => {
    initProductHeroSlider(slider);
  });

  function initProductHeroSlider(slider) {
    const sliderWrap = slider.closest('.product-hero__slider');
    const prevButton = sliderWrap.querySelector('.swiper-button-prev');
    const nextButton = sliderWrap.querySelector('.swiper-button-next');
    const pagination = slider.querySelector('.swiper-pagination');
    const slideCount = slider.querySelectorAll('.swiper-slide').length;

    const sliderOptions = {
      spaceBetween: 6,
      slidesPerView: 'auto',
      autoWidth: true,
      loop: slideCount > 1,
      autoplay: slideCount > 1 ? {
        delay: 3000,
        disableOnInteraction: true,
      } : false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      pagination: {
        el: pagination,
        clickable: true,
        dynamicBullets: false,
      },
      breakpoints: {
        992: {
          slidesPerView: "auto",
          pagination: {
            enabled: false,
          },
        },
      },
    };

    new Swiper(slider, sliderOptions);
  }
})();
